import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    tileGridClassName,
    HeaderClassName,
    gridClassName,
    labelClassName,
    buttonClassName,
} from '@archipro-design/aria';

export const ProductRangeWrapper: StyleRule = ({ theme }) => ({
    marginBottom: pxToRem(80),

    [theme.screen.min.tablet]: {
        marginBottom: pxToRem(240),
    },

    [`& .${tileGridClassName}`]: {
        marginBottom: pxToRem(35),

        [`& .${HeaderClassName}`]: {
            marginBottom: pxToRem(23),
            padding: pxArrayToRem([0, 18, 0, 18]),
            fontSize: pxToRem(18),
            lineHeight: 1,
            letterSpacing: theme.siteVariables.letterSpacingSmall,
            whiteSpace: 'unset',
            textAlign: 'left',
            fontWeight: '500',

            // Bug applying maximumLines to header - remove once fixed
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',

            [theme.screen.min.tablet]: {
                fontSize: pxToRem(22),
                marginLeft: pxToRem(922),
                padding: pxArrayToRem([0, 0, 60, 0]),
                marginBottom: 0,
                whiteSpace: 'pre-line',
                textAlign: 'left',
                letterSpacing: theme.siteVariables.letterSpacingSmall,
            },
        },

        [theme.screen.min.tablet]: {
            marginBottom: pxToRem(52),
        },
    },
});

export const ViewRangeButton: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    [`&.${buttonClassName}`]: {
        padding: pxArrayToRem([24, 42]),
        border: `1px solid ${siteVariables.colors.charcoal['250']}`,
        textTransform: 'uppercase',

        [`& .${labelClassName}`]: {
            fontWeight: 500,
            letterSpacing: siteVariables.letterSpacingMedium,
        },

        [screen.max.tablet]: {
            background: 'transparent',
            width: '100%',
            margin: pxArrayToRem([0, 19]),
            padding: pxArrayToRem([15, 16]),
            border: 'none',
            outline: `${pxToRem(1)} solid ${
                siteVariables.colors.charcoal['250']
            }`,
            [`& .${labelClassName}`]: {
                fontSize: siteVariables.fontSizes['label02'],
                color: siteVariables.colors.charcoal['250'],
                fontWeight: 500,
            },
        },
    },
});

export const ProductRangeGrid: StyleRule = ({ theme: { screen } }) => ({
    [`& .${gridClassName}`]: {
        gridColumnGap: pxToRem(6),
        gridRowGap: pxToRem(33),
        [screen.min.tablet]: {
            gridColumnGap: pxToRem(0),
        },
    },
});
